namespace Solovis.UI.InputControls {

    /**
     * BooleanInputControl is a UI element for entering a boolean value. Note that
     * it does not derive from BaseControl.
     */
    export class BooleanInputControl {

        public _container: any;
        public _readonly: boolean;
        public _value: boolean;
        public _isDirty: boolean;
        public _labelText: string;
        public _display: any;
        public _cssRules: any;
        public _validationModel: any;
        public _validate: any;
        public _change: any;
        public _onInvalid: any;
        public _onValid: any;

        public _label: JQuery;
        public _input: JQuery;

        constructor(
            options: {
                container: any,
                validationModel?: any,
                readonly?: boolean,
                value?: any,
                display?: any,
                labelText?: string,
                cssRules?: { rule: string, value: any }[],
                validate?: any,
                change?: any,
                onInvalid?: any,
                onValid?: any
            }
        ) {
            if (!options.container) {
                throw "Solovis.UI.InputControls.BooleanInputControl - Missing required parameter: container.";
            }

            if (!options.validationModel) {
                throw "Solovis.UI.InputControls.BooleanInputControl - Missing required parameter: validationModel.";
            }

            this._isDirty = false;

            // Base options
            this._container = options.container;
            this._readonly = options.readonly ? options.readonly : null;
            this._value = Solovis.isNotNull(options.value) ? !!options.value : null;
            this._labelText = options.labelText ? options.labelText : null;
            this._display = options.display ? options.display : null;
            this._cssRules = options.cssRules ? options.cssRules : null;

            this._validationModel = options.validationModel;

            // Events
            this._validate = options.validate ? options.validate : null;
            this._change = options.change ? options.change : null;
            this._onInvalid = options.onInvalid ? options.onInvalid : null;
            this._onValid = options.onValid ? options.onValid : null;

            this._render();
        }

        public _render() {
            var self = this;

            this._container.addClass("solovis-input");

            this._label = $("<label>")
                .css("margin-bottom", "1px")
                .text(this._labelText ? this._labelText : "")
                .appendTo(this._container);

            this._input = $("<input>")
                .attr("type", "checkbox")
                .css("vertical-align", "middle")
                .css("position", "relative")
                .css("margin", this._labelText ? "0 5px" : "0")
                .css("top", "-2px")
                .css("cursor", this._readonly ? "not-allowed" : null)
                .appendTo(this._label)
                .prop("checked", this._value ? true : false)
                .attr("readonly", this._readonly ? "" : null)
                .css("display", function () {
                    if (self._display) {
                        if (self._display.showInput === false) {
                            return "none";
                        }
                    }
                    return null;
                })
                .change(function () {
                    self._value = self._input.prop("checked");
                    self.notifyValueChanged();
                });

            if (this._cssRules) {
                Solovis.UI.DomHelper.applyCssRules(this._input, this._cssRules);
            }
        }

        public value(value?) {
            if (arguments.length) {
                this.setValue(value);
            }
            return this.getValue();
        }

        public getValue() {
            return this._value;
        }

       public setValue(newValue) {
            this._value = newValue;
            this._input.prop("checked", this._value ? true : false);

            this.doValidate();

            this.notifyValueChanged();
        }

        public doValidate() {
            var isValid = true;
            if (this._validate) {
                var customValidationResults = this._validate();
                isValid = customValidationResults.isValid;
                if (!customValidationResults.isValid) {
                    this._handleInvalid(customValidationResults.message);
                }
                else {
                    this._handleValid();
                }
            }
            return isValid;
        }

        public _handleInvalid(message) {
            var self = this;
            this._validationModel.setErrorMessage(message);

            if (this._onInvalid) {
                this._onInvalid();
            }
        }

        public isValid() {
            return this.doValidate();
        }

        public notifyValueChanged() {
            $(this).trigger("valueChanged");
            if (this._change) {
                this._change();
            }
        }

        public _handleValid = function () {
            this._validationModel.state(null);

            if (this._onValid) {
                this._onValid();
            }
        }
    }

}
